export const makeModelData = () => {
    const makeAndModel = [
        {
            "brand": "Audi",
            "models": [
                "A3 · S3 · RS3",
                "A4 · S4 · RS4",
                "A5 · S5 · RS5",
                "A6 · S6 · RS6",
                "A7 · S7 · RS7",
                "A8 · S8",
                "Q3 · RS Q3",
                "Q5 · SQ5",
                "Q7 · SQ7",
                "Q8 · SQ8 · RS Q8",
                "R8",
                "TT · TTS · TT RS"
            ]
        },
        {
            "brand": "BMW",
            "models": [
                "1 Series",
                "2 Series",
                "3 Series",
                "4 Series",
                "5 Series",
                "6 Series",
                "7 Series",
                "8 Series",
                "i Series",
                "X3 Series",
                "X4 Series",
                "X5 Series",
                "X6 Series",
                "Z3 Series",
                "Z4 Series",
                "Z8 Series"
            ]
        },
        {
            "brand": "Porsche",
            "models": [
                "911",
                "Boxster",
                "Cayenne",
                "Cayman",
                "Macan"
            ]
        },
        {
            "brand": "Toyota",
            "models": [
                "Supra"
            ]
        },
        {
            "brand": "INEOS",
            "models": [
                "Grenadier"
            ]
        },
        {
            "brand": "Mercedes-Benz",
            "models": [
                "A Class",
                "AMG GT",
                "C Class",
                "CLA Coupe",
                "CLS Class",
                "E Class",
                "G Class",
                "GLA Class",
                "GLC Class",
                "GLE Class",
                "S Class",
                "SL C"
            ]
        },
        {
            "brand": "VW",
            "models": [
                "Arteon",
                "Atlas · Atlas Cross Sport",
                "Beetle",
                "CC",
                "EOS",
                "Golf · GTI · R · Rabbit",
                "Jetta · GLI",
                "Passat",
                "Tiguan",
                "Touareg"
            ]
        }
    ]
    return makeAndModel;
}

export const yearModelData = () => {
    const yearData = [
        {
            "brand": "Audi",
            "models": {
                "A3": [
                    "8L (1996 - 2003)",
                    "8P (2006 - 2013)",
                    "8V (2015 - 2020)",
                    "8Y (2022 - Present)"
                ],
                "A4": [
                    "C4 (1991 - 1994)",
                    "B5 (1996 - 2002)",
                    "B6 (2002 - 2005)",
                    "B7 (2005 - 2009)",
                    "B8 - B8.5 (2009 - 2016)",
                    "B9 (2017 - Present)"
                ],
                "A5": [
                    "B8 - B8.5 (2008 - 2016)",
                    "B9 (2017 - Present)"
                ],
                "A6": [
                    "C4 (1991 - 1994)",
                    "C5 (1998 - 2004)",
                    "C6 (2005 - 2011)",
                    "C7 - C7.5 (2012 - 2019)",
                    "C8 (2020 - Present)"
                ],
                "A7": [
                    "C7 - C7.5 (2012 - 2019)",
                    "C8 (2020 - Present)"
                ],
                "A8": [
                    "D2 (1997 - 2003)",
                    "D3 (2004 - 2010)",
                    "D4 (2011 - 2017)",
                    "D5 (2018 - Present)"
                ],
                "Q3": [
                    "8U (2015 - 2017)",
                    "F3 (2018 - Present)"
                ],
                "Q5": [
                    "8R (2009 - 2017)",
                    "80A (2018 - Present)"
                ],
                "Q7": [
                    "4L (2007 - 2015)",
                    "4M (2016 - Present)"
                ],
                "Q8": [
                    "4M (2019 - Present)"
                ],
                "R8": [
                    "42 (2008 - 2016)",
                    "4S (2017 - Present)"
                ],
                "TT": [
                    "8N (2000 - 2006)",
                    "8J (2008 - 2015)",
                    "8S (2016 - Present)"
                ]
            }
        },
        {
            "brand": "BMW",
            "models": {
                "1 Series": [
                    "E81 · E82 · E87 · E88 (2004 - 2010)",
                    "F20 · F21 (2011 - 2018)"
                ],
                "2 Series": [
                    "F22 · F23 · F87 (2014 - 2020)",
                    "G42 · G43 · G87 (2021 - Present)"
                ],
                "3 Series": [
                    "E30 (1982 - 1990)",
                    "E36 (1990 - 1998)",
                    "E36-5 (1994 - 2000)",
                    "E46 (1999 - 2005)",
                    "E90 · E91 · E92 · E93 (2006 - 2012)",
                    "F30 · F80 (2012 - 2019)",
                    "G20 · G80 (2019 - Present)"
                ],
                "4 Series": [
                    "F32 · F33 · F36 · F82 · F83 (2014 - 2019)",
                    "G22 · G23 · G26 · G82 · G83 (2020 - Present)"
                ],
                "5 Series": [
                    "E28 (1981 - 1988)",
                    "E34 (1988 - 1996)",
                    "E39 (1996 - 2003)",
                    "E60 · E61 (2004 - 2010)",
                    "F10 · F11 · F07 · F18 (2011 - 2016)",
                    "G30 · F90 (2017 - Present)"
                ],
                "6 Series": [
                    "E63 · E64 (2005 - 2010)",
                    "F06 · F12 · F13 (2012 - 2018)"
                ],
                "7 Series": [
                    "E38 (1995 - 2000)",
                    "E65 · E66 · E67 · E68 (2001 - 2008)",
                    "F01 · F02 · F03 · F04 (2009 - 2014)",
                    "G11 · G12 (2015 - 2021)"
                ],
                "8 Series": [
                    "G14 · G15 · G16 · F91 · F92 · F93 (2018 - Present)"
                ],
                "i Series": [
                    "I12 (2014 - Present)"
                ],
                "X3 Series": [
                    "E83 (2003 - 2010)",
                    "F25 (2010 - 2016)",
                    "G01 (2017-2024)"
                ],
                "X4 Series": [
                    "F26 (2014 - 2017)",
                    "G02 (2018 - Present)"
                ],
                "X5 Series": [
                    "E53 (2000 - 2006)",
                    "E70 (2007 - 2013)",
                    "F15 · F85 (2014 - 2018)",
                    "G05 · G18(2019 - Present)"
                ],
                "X6 Series": [
                    "E71 (2008 - 2014)",
                    "F16 · F86 (2015 - 2019)",
                    "G06 (2020 - Present)"
                ],
                "Z3 Series": [
                    "E36-7 · E36-8 (1996 - 2002)"
                ],
                "Z4 Series": [
                    "E85 · E86 (2003 - 2008)",
                    "E89 (2009 - 2016)",
                    "G29 (2018 - Present)"
                ],
                "Z8 Series": [
                    "E52 (1999 - 2006)"
                ]
            }
        },
        {
            "brand": "Porsche",
            "models": {
                "911": [
                    "964 (1989 - 1994)",
                    "993 (1995 - 1998)",
                    "996 (1998 - 2005)",
                    "997.1 (2005 - 2008)",
                    "997.2 (2009 - 2012)",
                    "991.1 (2012 - 2016)",
                    "991.2 (2017 - 2019)"
                ],
                "Boxster": [
                    "986 (1996 - 2003)",
                    "987 (2004 - 2011)",
                    "981 (2012 - 2016)",
                    "982 718 (2017 - Present)"
                ],
                "Cayenne": [
                    "955 · 957 (2002 - 2010)",
                    "958 (2011 - 2018)"
                ],
                "Cayman": [
                    "987 (2006 - 2012)",
                    "981 (2013 - 2016)",
                    "982 718 (2017 - Present)"
                ],
                "Macan": [
                    "95B (2014 - Present)"
                ]
            }
        },
        {
            "brand": "INEOS",
            "models": {
                "Grenadier": [
                    "Grenadier (2023 - Present)"
                ]
            }
        },
        {
            "brand": "Toyota",
            "models": {
                "Supra": [
                    "A90 · A91 (2019 - Present)"
                ]
            }
        },
        {
            "brand": "Mercedes-Benz",
            "models": {
                "A Class": [
                    "W176 (2013 - 2018)",
                    "W177 (2019 - 2022)"
                ],
                "AMG GT": [
                    "C190 (2015 - Present)",
                    "X290 4-door (2019 - Present)"
                ],
                "C Class": [
                    "W205 (2015 - 2021)",
                    "W206 (2022 - Present)"
                ],
                "CLA Coupe": [
                    "C117/X117 (2014 - 2019)",
                    "C118/X118 (2020 - Present)"
                ],
                "CLS Class": [
                    "C218 (2012 - 2018)"
                ],
                "E Class": [
                    "W212 (2010 - 2016)",
                    "W213 (2017 - 2023)"
                ],
                "G Class": [
                    "W463 (2019 - Present)",
                ],
                "GLA Class": [
                    "X156 (2014 - 2020)"
                ],
                "GLC Class": [
                    "C253/X253 (2016 - 2022)"
                ],
                "GLE Class": [
                    "W167 (2019 - Present)"
                ],
                "S Class": [
                    "W222 (2014 - 2020)"
                ],
                "SL Class": [
                    "W206 (2013 - 2020)"
                ]
            }
        },
        {
            "brand": "VW",
            "models": {
                "Arteon": [
                    "MK1 (2019 - Present)"
                ],
                "Atlas": [
                    "MK1 (2018 - Present)"
                ],
                "Beetle": [
                    "MK1 (1998 - 2010)",
                    "5C (2012 - 2019)"
                ],
                "CC": [
                    "B6 (2009 - 2017)"
                ],
                "EOS": [
                    "1F (2006 - 2016)"
                ],
                "Golf": [
                    "MK2 (1983 - 1991)",
                    "MK3 (1992 - 1998)",
                    "MK4 (1999 - 2006)",
                    "MK5 (2006 - 2009)",
                    "MK6 (2010 - 2014)",
                    "MK7 · MK7.5 (2015 - 2021)",
                    "MK8 (2022-2024)",
                    "MK8.5 (2025+)"
                ],
                "Jetta": [
                    "MK2 (1984 - 1991)",
                    "MK3 (1992 - 1998)",
                    "MK4 (1999 - 2005)",
                    "MK5 (2005 - 2010)",
                    "MK6 (2011 - 2018)",
                    "MK7 (2019 - Present)"
                ],
                "Passat": [
                    "B3 (1990 - 1994)",
                    "B4 (1995 - 1997)",
                    "B5 (1998 - 2005)",
                    "B6 (2006 - 2010)",
                    "B7 (2012 - 2019)",
                    "B8 (2020+)"
                ],
                "Tiguan": [
                    "5N (2009 - 2017)",
                    "5NA (2018 - Present)"
                ],
                "Touareg": [
                    "7L (2002 - 2010)",
                    "7P (2011 - 2017)"
                ]
            }
        }
    ]
    return yearData;
}

export const engineData = () => {
    const data =[
        {
            "Audi": {
                "A3-8L": {
                    "models": {
                        "A3 1.8T I4": "/collections/8l-a3-1-8t-i4/",
                        "A3 1.9 TDI": "/collections/8l-a3-1-9-tdi/",
                        "S3 1.8T I4": "/collections/8l-s3-1-8t-i4/"
                    }
                },
                "A3-8P": {
                    "models": {
                        "A3 1.8T I4": "/collections/8p-a3-1-8t-i4/",
                        "A3 2.0T I4": "/collections/8p-a3-2-0t-i4/",
                        "A3 3.2L VR6": "/collections/8p-a3-3-2l-vr6/",
                        "A3 2.0L TDI I4": "/collections/8p-a3-2-0l-tdi-i4/",
                        "S3 2.0T I4": "/collections/8p-s3-2-0t-i4/",
                        "RS3 2.5T I5": "/collections/8p-rs3-2-5t-i5"
                    }
                },
                "A3-8V": {
                    "models": {
                        "A3 1.8T I4 [MQB]": "/collections/8v-a3-1-8t-i4-mqb/",
                        "A3 2.0T I4 [MQB]": "/collections/8v-a3-2-0t-i4-mqb/",
                        "A3 2.0L TDI I4 [MQB]": "/collections/8v-a3-2-0l-tdi-i4-mqb/",
                        "S3 2.0T I4 [MQB]": "/collections/8v-s3-2-0t-i4-mqb/",
                        "RS3 2.5T I5 [MQB]": "/collections/8v-rs3-2-5t-i5-mqb"
                    }
                },
                "A3-8Y": {
                    "models": {
                        "A3 2.0T I4 [MQB Evo]": "/collections/8y-a3-2-0t-i4-mqb-evo/",
                        "S3 2.0T I4 [MQB Evo]": "/collections/8y-s3-2-0t-i4-mqb-evo/",
                        "RS3 2.5T I5 [MQB Evo]": "/collections/8y-rs3-2-5t-i5-mqb-evo/"
                    }
                },
                "A4-C4": {
                    "models": {
                        "S4 2.2T I5": "/collections/c4-s4-2-2t"
                    }
                },
                "A4-B5": {
                    "models": {
                        "A4 1.8T I4": "/collections/b5-a4-1-8t-i4/",
                        "A4 2.8L V6": "/collections/b5-a4-2-8l-v6/",
                        "S4 2.7T V6": "/collections/b5-s4-2-7t-v6/",
                        "RS4 2.7T V6": "/collections/b5-rs4-2-7t-v6/"
                    }
                },
                "A4-B6": {
                    "models": {
                        "A4 1.8T I4": "/collections/b6-a4-1-8t-i4/",
                        "A4 3.0 V6": "/collections/b6-a4-3-0-v6/",
                        "S4 4.2L V8": "/collections/b6-s4-4-2l-v8/"
                    }
                },
                "A4-B7": {
                    "models": {
                        "A4 1.8T I4": "/collections/b7-a4-1-8t-i4/",
                        "A4 2.0T I4": "/collections/b7-a4-2-0t-i4/",
                        "A4 3.2L V6": "/collections/b7-a4-3-2l-v6/",
                        "S4 4.2L V8": "/collections/b7-s4-4-2l-v8/",
                        "RS4 4.2L V8": "/collections/b7-rs4-4-2l-v8/"
                    }
                },
                "A4-B8": {
                    "models": {
                        "A4 2.0T I4": "/collections/b8-a4-2-0t-i4/",
                        "A4 3.2L V6": "/collections/b8-a4-3-2l-v6/",
                        "A4 2.0 TDI": "/collections/b8-a4-2-0-tdi/",
                        "A4 3.0 TDI": "/collections/b8-a4-3-0-tdi/",
                        "S4 3.0L SC V6": "/collections/b8-s4-3-0l-sc-v6/",
                        "RS4 4.2L V8": "/collections/b8-rs4-4-2l-v8"
                    }
                },
                "A4-B9": {
                    "models": {
                        "A4 1.4T I4": "/collections/b9-a4-1-4t-i4/",
                        "A4 2.0T I4": "/collections/b9-a4-2-0t-i4/",
                        "Allroad 2.0T I4": "/collections/b9-allroad-2-0t-i4/",
                        "S4 3.0T V6": "/collections/b9-s4-3-0t-v6/",
                        "S4 3.0 TDI": "/collections/b9-s4-3-0-tdi/",
                        "RS4 2.9T V6": "/collections/b9-rs4-2-9t-v6"
                    }
                },
                "A5-B8": {
                    "models": {
                        "A5 2.0T I4": "/collections/b8-a5-2-0t-i4/",
                        "A5 3.2L V6": "/collections/b8-a5-3-2l-v6/",
                        "A5 2.0 TDI": "/collections/b8-a5-2-0-tdi/",
                        "A5 3.0 TDI": "/collections/b8-a5-3-0-tdi/",
                        "S5 3.0L SC V6": "/collections/b8-s5-3-0l-sc-v6/",
                        "S5 4.2L V8": "/collections/b8-s5-4-2l-v8/",
                        "RS5 4.2L V8": "/collections/b8-rs5-4-2l-v8"
                    }
                },
                "A5-B9": {
                    "models": {
                        "A5 2.0T I4": "/collections/b9-a5-2-0t-i4/",
                        "A5 3.0 TDI": "/collections/b9-a5-3-0-tdi/",
                        "S5 3.0T V6": "/collections/b9-s5-3-0t-v6/",
                        "S5 3.0 TDI": "/collections/b9-s5-3-0-tdi/",
                        "RS5 2.9T V6": "/collections/b9-rs5-2-9t-v6"
                    }
                },
                "A6-C4": {
                    "models": {
                        "A6 2.7T V6": "/collections/c4-s6-2-2t/"
                    }
                },
                "A6-C5": {
                    "models": {
                        "Allroad 2.7T V6": "/collections/c5-allroad-2-7t-v6/",
                        "A6 2.8L V6": "/collections/c5-a6-2-8l-v6/",
                        "A6 3.0L V6": "/collections/c5-a6-3-0l-v6/",
                        "A6 2.7T V6": "/collections/c5-a6-2-7t-v6/",
                        "A6 4.2L V8": "/collections/c5-a6-4-2l-v8/",
                        "S6 4.2L V8": "/collections/c5-s6-4-2l-v8/",
                        "RS6 4.2T V8": "/collections/c5-rs6-4-2t-v8/"
                    }
                },
                "A6-C6": {
                    "models": {
                        "A6 3.0L SC V6": "/collections/c6-a6-3-0l-sc-v6/",
                        "A6 3.2L V6": "/collections/c6-a6-3-2l-v6/",
                        "A6 4.2L V8": "/collections/c6-a6-4-2l-v8/",
                        "S6 5.2L V10": "/collections/c6-s6-5-2l-v10/",
                        "RS6 5.0T V10": "/collections/c6-rs6-5-0t-v10/"
                    }
                },
                "A6-C7": {
                    "models": {
                        "A6 2.0T I4": "/collections/c7-a6-2-0t-i4/",
                        "A6 3.0L SC V6": "/collections/c7-a6-3-0l-sc-v6/",
                        "A6 2.0 TDI": "/collections/c7-a6-2-0-tdi/",
                        "A6 3.0 TDI": "/collections/c7-a6-3-0-tdi/",
                        "S6 4.0T V8": "/collections/c7-s6-4-0t-v8/",
                        "RS6 4.0T V8": "/collections/c7-rs6-4-0t-v8/"
                    }
                },
                "A6-C8": {
                    "models": {
                        "A6 2.0T I4": "/collections/c8-a6-2-0t-i4/",
                        "A6 3.0T V6": "/collections/c8-a6-3-0t-v6/",
                        "S6 2.9T V6": "/collections/c8-s6-2-9t-v6/",
                        "S6 3.0 TDI": "/collections/c8-s6-3-0-tdi/",
                        "RS6 4.0T V8": "/collections/c8-rs6-4-0t-v8/"
                    }
                },
                "A7-C7": {
                    "models": {
                        "A7 3.0L SC V6": "/collections/c7-a7-3-0l-sc-v6/",
                        "A7 3.0 TDI": "/collections/c7-a7-3-0-tdi/",
                        "S7 4.0T V8": "/collections/c7-s7-4-0t-v8/",
                        "RS7 4.0T V8": "/collections/c7-rs7-4-0t-v8-1/"
                    }
                },
                "A7-C8": {
                    "models": {
                        "A7 2.0T I4": "/collections/c8-a7-2-0t-i4/",
                        "A7 3.0T V6": "/collections/c8-a7-3-0t-v6/",
                        "S7 2.9T V6": "/collections/c8-s7-2-9t-v6/",
                        "S7 3.0 TDI": "/collections/c8-s7-3-0-tdi/",
                        "RS7 4.0T V8": "/collections/c8-rs7-4-0t-v8/"
                    }
                },
                "A8-D2": {
                    "models": {
                        "A8 4.2L V8": "/collections/d2-a8-4-2l-v8/",
                        "S8 4.2L V8": "/collections/d2-s8-4-2l-v8/"
                    }
                },
                "A8-D3": {
                    "models": {
                        "A8 4.2L V8": "/collections/d3-a8-4-2l-v8/",
                        "S8 5.2L V10": "/collections/d3-s8-5-2l-v10/"
                    }
                },
                "A8-D4": {
                    "models": {
                        "A8 3.0L SC V6": "/collections/d4-a8-3-0l-sc-v6/",
                        "A8 4.0T V8": "/collections/d4-a8-4-0t-v8/",
                        "A8 4.2L V8": "/collections/d4-a8-4-2l-v8/",
                        "S8 4.0T V8": "/collections/d4-s8-4-0t-v8/"
                    }
                },
                "A8-D5": {
                    "models": {
                        "A8 3.0T V6": "/collections/d5-a8-3-0t-v6/",
                        "A8 4.0T V8": "/collections/d5-a8-4-0t-v8/",
                        "S8 4.0T V8": "/collections/d5-s8-4-0t-v8/"
                    }
                },
                "Q3-8U": {
                    "models": {
                        "Q3 2.0T I4": "/collections/8u-q3-2-0t-i4/",
                        "RS Q3 2.5T I5": "/collections/8u-rs-q3-2-5t-i5/"
                    }
                },
                "Q3-F3": {
                    "models": {
                        "Q3 2.0T I4 [MQB]": "/collections/f3-q3-2-0t-i4-mqb",
                        "RS Q3 2.5T I5": "/collections/f3-rs-q3-2-5t-i5/"
                    }
                },
                "Q5-8R": {
                    "models": {
                        "Q5 2.0T I4": "/collections/8r-q5-2-0t-i4/",
                        "Q5 3.0L SC V6": "/collections/8r-q5-3-0l-sc-v6/",
                        "SQ5 3.0L SC V6": "/collections/8r-sq5-3-0l-sc-v6/",
                        "SQ5 3.0 TDI": "/collections/8r-sq5-3-0-tdi/"
                    }
                },
                "Q5-80A": {
                    "models": {
                        "Q5 2.0T I4": "/collections/80a-q5-2-0t-i4/",
                        "SQ5 3.0T V6": "/collections/80a-sq5-3-0t-v6"
                    }
                },
                "Q7-4L": {
                    "models": {
                        "Q7 3.0 TDI": "/collections/4l-q7-3-0-tdi/",
                        "Q7 3.0L SC V6": "/collections/4l-q7-3-0l-sc-v6/"
                    }
                },
                "Q7-4M": {
                    "models": {
                        "Q7 3.0 SC V6": "/collections/4m-q7-3-0-sc-v6/",
                        "Q7 3.0 TDI": "/collections/4m-q7-3-0-tdi/",
                        "SQ7 4.0T V8": "/collections/4m-sq7-4-0t-v8/",
                        "SQ7 4.0 V8 TDI": "/collections/4m-sq7-4-0-v8-tdi/"
                    }
                },
                "Q8-4M": {
                    "models": {
                        "Q8 3.0 SC V6": "/collections/4m-q8-3-0-sc-v6/",
                        "Q8 55 TDI": "/collections/4m-q8-55-tdi/",
                        "SQ8 4.0T V8": "/collections/4m-sq8-4-0t-v8/",
                        "RS Q8 4.0T V8": "/collections/4m-rsq8-4-0t-v8/"
                    }
                },
                "R8-42": {
                    "models": {
                        "R8 4.2L V8": "/collections/42-r8-4-2l-v8/",
                        "R8 5.2L V10": "/collections/42-r8-5-2l-v10/"
                    }
                },
                "42-4S": {
                    "models": {
                        "R8 5.2L V10": "/collections/4s-r8-5-2l-v10/",
                        "R8 5.2L V10 PLUS": "/collections/4s-r8-5-2l-v10-plus/"
                    }
                },
                "TT-8N": {
                    "models": {
                        "TT 1.8T I4": "/collections/8n-tt-1-8t-i4/",
                        "TT 3.2L VR6": "/collections/8n-tt-3-2l-vr6/"
                    }
                },
                "TT-8J": {
                    "models": {
                        "TT 2.0T I4": "/collections/8j-tt-2-0t-i4/",
                        "TT 3.2L VR6": "/collections/8j-tt-3-2l-vr6/",
                        "TTS 2.0T I4": "/collections/8j-tts-2-0t-i4/",
                        "TT RS 2.5T I5": "/collections/8j-tt-rs-2-5t-i5/"
                    }
                },
                "TT-8S": {
                    "models": {
                        "TT 2.0T I4 [MQB]": "/collections/8s-tt-2-0t-i4-mqb/",
                        "TTS 2.0T I4 [MQB]": "/collections/8s-tts-2-0t-i4-mqb/",
                        "TT RS 2.5T I5 [MQB]": "/collections/8s-tt-rs-2-5t-i5-mqb"
                    }
                }
            }
        },
        {
            "BMW": {
                "E81": {
                    "models": {
                        "128i 3.0L I6 [N52]": "/collections/e82-e88-128i-3-0l-i6-n52/",
                        "135i 3.0T I6 [N54]": "/collections/e82-e88-135i-3-0t-i6-n54/",
                        "135i 3.0T I6 [N55]": "/collections/e82-e88-135i-3-0t-i6-n55/",
                        "E81 118d-123d M Sport 2.0T [N47]": "/collections/e81-118d-123d-m-sport-2-0t-n47/",
                        "E82 118d-123d M Sport 2.0T [N47]": "/collections/e82-118d-123d-m-sport-2-0t-n47/",
                        "E87 118d-123d M Sport 2.0T [N47]": "/collections/e87-118d-123d-m-sport-2-0t-n47/",
                        "1M 3.0T I6 [N54]": "/collections/e82-e88-1m-3-0t-i6-n54/"
                    }
                },
                "F20": {
                    "models": {
                        "F20 114i-120i 1.6T I4 [N13]": "/collections/f20-114i-120i-1-6t-i4-n13/",
                        "F20 125i 2.0T I4 [B48]": "/collections/f20-125i-2-0t-i4-b48/",
                        "F21 114i-120i 1.6T I4 [N13]": "/collections/f21-114i-120i-1-6t-i4-n13/",
                        "F21 125i 2.0T I4 [B48]": "/collections/f21-125i-2-0t-i4-b48/",
                        "M135i 3.0T I6 [N55]": "/collections/f20-f21-m135i-3-0t-i6-n55/",
                        "M140i 3.0T I6 [B58]": "/collections/f20-f21-m140i-3-0t-i6-b58/"
                    }
                },
                "F22": {
                    "models": {
                        "220i 2.0T I4 [N20]": "/collections/f22-f23-f87-220i-2-0t-i4-n20/",
                        "228i 2.0T I4 [N20]": "/collections/f22-f23-f87-228i-2-0t-i4-n20/",
                        "228i 2.0T I4 [N26]": "/collections/f22-228i-2-0t-i4-n26/",
                        "230i 2.0T I4 [B48]": "/collections/f22-230i-2-0t-i4-b48/",
                        "M235i 3.0T I6 [N55]": "/collections/f22-f23-f87-m235i-3-0t-i6-n55/",
                        "M240i 3.0T I6 [B58]": "/collections/f22-f23-f87-m240i-3-0t-i6-b58/",
                        "M2 3.0T I6 [N55]": "/collections/f22-f23-f87-m2-3-0t-i6-n55/",
                        "M2 Competition 3.0T I6 [S55]": "/collections/f22-f23-f87-m2-competition-3-0t-i6-s55/",
                        "F87 M2 CS 3.0T I6 [S55]": "/collections/f87-m2-cs-3-0t-i6-s55/"
                    }
                },
                "G42": {
                    "models": {
                        "228i 2.0T I4 [B48]": "/collections/g42-228i-2-0t-i4-b48",
                        "M240i 3.0T I6 [B58]": "/collections/g42-m240i-3-0t-i6-b58/",
                        "M2 3.0T I6 [S58]": "/collections/g87-m2-3-0t-i6-s58"
                    }
                },
                "E30": {
                    "models": {
                        "316 1.8L I4 [M10]": "/collections/e30-316-1-8l-i4-m10/",
                        "318i 1.8L I4 [M10]": "/collections/e30-318i-1-8l-i4-m10/",
                        "318i 1.8L I4 [M40]": "/collections/e30-318i-1-8l-i4-m40/",
                        "318is 1.8L I4 [M42]": "/collections/e30-318is-1-8l-i4-m42/",
                        "320i 2.0L I6 [M20]": "/collections/e30-320i-2-0l-i6-m20/",
                        "323i 2.3L I6 [M20]": "/collections/e30-323i-2-3l-i6-m20/",
                        "325 2.7L I6 [M20]": "/collections/e30-325-2-7l-i6-m20/",
                        "325i 2.5L I6 [M20]": "/collections/e30-325i-2-5l-i6-m20/",
                        "M3 2.3L I4 [S14]": "/collections/e30-m3-2-3l-i4-s14/"
                    }
                },
                "E36": {
                    "models": {
                        "E36 318is 1.8L I4 [M42]": "/collections/e36-1-8l-i4-m42/",
                        "318is 1.9L I4 [M44]": "/collections/e36-1-9l-i4-m44/",
                        "E36 320i 2.5L I6 [M50]": "/collections/e36-2-5l-i6-m50/",
                        "E36 325i 2.5L I6 [M52]": "/collections/e36-2-5l-i6-m52/",
                        "328i 2.8L I6 [M52]": "/collections/e36-2-8l-i6-m52/",
                        "M3 3.0L I6 [S50]": "/collections/e36-3-0l-i6-s50/",
                        "M3 3.2L I6 [S52]": "/collections/e36-3-2l-i6-s52/"
                    }
                },
                "E36-5": {
                    "models": {
                        "323ti 2.5L I6 [M52]": "/collections/e36-5-323ti-2-5l-i6-m52",
                        "318ti 1.8L I4 [M42]": "/collections/e36-5-318ti-1-8l-i4-m42",
                        "318ti 1.9L I4 [M44]": "/collections/e36-5-318ti-1-9l-i4-m44"
                    }
                },
                "E46": {
                    "models": {
                        "323i 2.5L I6 [M52]": "/collections/e46-323i-2-5l-i6-m52/",
                        "325i 2.5L I6 [M54]": "/collections/e46-325i-2-5l-i6-m54/",
                        "325xi 2.5L I6 [M54]": "/collections/e46-325xi-2-5l-i6-m54/",
                        "328i 2.8L I6 [M52]": "/collections/e46-328i-2-8l-i6-m52/",
                        "330xi 3.0L I6 [M54]": "/collections/e46-330xi-3-0l-i6-m54/",
                        "M3 3.2L I6 [S54]": "/collections/e46-m3-3-2l-i6-s54/",
                        "M3 4.0L V8 [P60]": "/collections/e46-m3-4-0l-v8-p60/"
                    }
                },
                "E90": {
                    "models": {
                        "E90 325i 3.0L I6 [N52]": "/collections/e90-325i-3-0l-i6-n52",
                        "E90 325i 2.5L I6 [N52]": "/collections/e90-325i-2-5l-i6-n52",
                        "E90 328i 3.0L I6 [N52]": "/collections/e90-328i-3-0l-i6-n52",
                        "E90 330i 3.0L I6 [N52]": "/collections/e90-330i-3-0l-i6-n52",
                        "E90 330i 3.0L I6 [N53]": "/collections/e90-330i-3-0l-i6-n53",
                        "E90 335i 3.0T I6 [N54]": "/collections/e90-335i-3-0t-i6-n54",
                        "E90 335i 3.0T I6 [N55]": "/collections/e90-335i-3-0t-i6-n55",
                        "E90 M3 4.0L V8 [S65]": "/collections/e90-m3-4-0l-v8-s65",
                        "E91 328i 3.0L I6 [N52]": "/collections/e91-328i-3-0l-i6-n52",
                        "E91 335i 3.0T I6 [N54]": "/collections/e91-335i-3-0t-i6-n54",
                        "E91 335i 3.0T I6 [N55]": "/collections/e91-335i-3-0t-i6-n55",
                        "E92 325i 2.5L I6 [N52]": "/collections/e92-325i-2-5l-i6-n52",
                        "E92 325i 3.0L I6 [N52]": "/collections/e92-325i-3-0l-i6-n52",
                        "E92 328i 3.0L I6 [N52]": "/collections/e92-328i-3-0l-i6-n52",
                        "E92 330i 3.0L I6 [N52]": "/collections/e92-330i-3-0l-i6-n52",
                        "E92 330i 3.0L I6 [N53]": "/collections/e92-330i-3-0l-i6-n53",
                        "E92 335i 3.0T I6 [N54]": "/collections/e92-335i-3-0t-i6-n54",
                        "E92 335i 3.0T I6 [N55]": "/collections/e92-335i-3-0t-i6-n55",
                        "E92 M3 4.0L V8 [S65]": "/collections/e92-m3-4-0l-v8-s65",
                        "E93 328i 3.0L I6 [N52]": "/collections/e93-328i-3-0l-i6-n52",
                        "E93 335i 3.0T I6 [N54]": "/collections/e93-335i-3-0t-i6-n54",
                        "E93 335i 3.0T I6 [N55]": "/collections/e93-335i-3-0t-i6-n55",
                        "E93 M3 4.0L V8 [S65]": "/collections/e93-m3-4-0l-v8-s65"
                    }
                },
                "F30": {
                    "models": {
                        "328i 2.0T I4 [N20]": "/collections/f30-f80-328i-2-0t-i4-n20/",
                        "335i 3.0T I6 [N55]": "/collections/f30-f80-335i-3-0t-i6-n55/",
                        "340i 3.0T I6 [B58]": "/collections/f30-f80-340i-3-0t-i6-b58/",
                        "F30 320i 2.0T I4 [N20]": "/collections/f30-320i-2-0t-i4-n20/",
                        "F31 320i 2.0T I4 [N20]": "/collections/f31-320i-2-0t-i4-n20/",
                        "F30 328d 2.0T I4 [N47]": "/collections/f30-328d-2-0t-i4-n47/",
                        "F31 328d 2.0T I4 [N47]": "/collections/f31-328d-2-0t-i4-n47/",
                        "F30 328i 2.0T I4 [N26]": "/collections/f30-328i-2-0t-i4-n26/",
                        "F31 328i 2.0T I4 [N26]": "/collections/f31-328i-2-0t-i4-n26/",
                        "F30 330i 2.0T I4 [B46]": "/collections/f30-330i-2-0t-i4-b46/",
                        "F31 330i 2.0T I4 [B46]": "/collections/f31-330i-2-0t-i4-b46/",
                        "M340i 3.0T I6 [B58]": "/collections/f30-f31-m340i-3-0t-i6-b58/",
                        "M3 3.0T I6 [S55]": "/collections/f30-f80-m3-3-0t-i6-s55/"
                    }
                },
                "G20": {
                    "models": {
                        "318i-320i 2.0T I4 [B48]": "/collections/g20-318i-320i-2-0t-i4-b48/",
                        "320i 1.6T I4 [N20]": "/collections/g20-320i-1-6t-i4-n20/",
                        "330e 2.0T I4 [B48]": "/collections/g20-330e-2-0t-i4-b48/",
                        "330i 2.0T I4 [B48]": "/collections/g20-330i-2-0t-i4-b48/",
                        "M340i 3.0T I6 [B58]": "/collections/g20-m340i-3-0t-i6-b58/",
                        "M3 3.0T I6 [S58]": "/collections/g80-m3-3-0t-i6-s58/"
                    }
                },
                "F32": {
                    "models": {
                        "428i 2.0T I4 [N20]": "/collections/f32-f33-f36-f82-f83-428i-2-0t-i4-n20/",
                        "F32 428i 2.0T I4 [N26]": "/collections/f32-428i-2-0t-i4-n26/",
                        "F32 430i 2.0T I4 [B46]": "/collections/f32-430i-2-0t-i4-b46/",
                        "435i 3.0T I6 [N55]": "/collections/f32-f33-f36-f82-f83-435i-3-0t-i6-n55/",
                        "440i 3.0T I6 [B58]": "/collections/f32-f33-f36-f82-f83-440i-3-0t-i6-b58/",
                        "F32-F33 M440i 3.0T I6 [B58]": "/collections/f32-f33-m440i-3-0t-i6-b58/",
                        "M4 3.0T I6 [S55]": "/collections/f32-f33-f36-f82-f83-m4-3-0t-i6-s55/"
                    }
                },
                "G22": {
                    "models": {
                        "430i 2.0T I4 [B48]": "/collections/g22-430i-2-0t-b48/",
                        "M440i 3.0T I6 [B58]": "/collections/g22-m440i-3-0t-b58/",
                        "G82 M4 3.0T I6 [S58]": "/collections/g82-m4-3-0t-i6-s58/",
                        "G83 M4 3.0T I6 [S58]": "/collections/g83-m4-3-0t-i6-s58/"
                    }
                },
                "E28": {
                    "models": {
                        "528i 2.8L I6 [M30]": "/collections/e28-528i-2-8l-i6-m30",
                        "535i 3.4L I6 [M30]": "/collections/e28-535i-3-4l-i6-m30",
                        "M535i 3.4L i6 [M30]": "/collections/e28-m535i-3-4l-i6-m30",
                        "M5 3.5L I6 [S38]": "/collections/e28-m5-3-5l-i6-s38"
                    }
                },
                "E34": {
                    "models": {
                        "525i 2.5L I6 [M20]": "/collections/e34-525i-2-5l-i6-m20",
                        "525i 2.5L I6 [M50]": "/collections/e34-525i-2-5l-i6-m50",
                        "530i 3.0L I6 [M60]": "/collections/e34-530i-3-0l-i6-m60",
                        "535i 3.4L I6 [M30]": "/collections/e34-535i-3-4l-i6-m30",
                        "540i 4.0L V8 [M60]": "/collections/e34-540i-4-0l-v8-m60"
                    }
                },
                "E39": {
                    "models": {
                        "525i 2.5L I6 [M54]": "/collections/e39-2-5l-i6-m54",
                        "528i 2.8L I6 [M52]": "/collections/e39-2-8l-i6-m52",
                        "530i 3.0L I6 [M54]": "/collections/e39-3-0l-i6-m54",
                        "M5 5.0L V8 [S62]": "/collections/e39-m5-5-0l-v8-s62"
                    }
                },
                "E60": {
                    "models": {
                        "E60 528i 3.0L I6 [N53]": "/collections/e60-528i-3-0l-i6-n53",
                        "E60 535i 3.0T I6 [N54]": "/collections/e60-535i-3-0t-i6-n54",
                        "E61 530xi 3.0L I6 [N52]": "/collections/e61-530xi-3-0l-i6-n52",
                        "E61 525i 2.5L I6 [N52]": "/collections/e61-525i-2-5l-i6-n52",
                        "E61 525i 3.0L I6 [N53]": "/collections/e61-525i-3-0l-i6-n53",
                        "E61 528i 3.0L I6 [N52]": "/collections/e61-528i-3-0l-i6-n52",
                        "E61 530i 3.0L I6 [N52]": "/collections/e61-530i-3-0l-i6-n52",
                        "E61 530i 3.0L I6 [N53]": "/collections/e61-530i-3-0l-i6-n53",
                        "E61 535i 3.0T I6 [N54]": "/collections/e61-535i-3-0t-i6-n54",
                        "M5 5.0L V10 [S85]": "/collections/e60-m5-5-0l-v10-s85"
                    }
                },
                "F10": {
                    "models": {
                        "F10 520i 2.0T I4 [N20]": "/collections/f10-520i-2-0t-i4-n20",
                        "F10 528i 2.0T I4 [N20]": "/collections/f10-528i-2-0t-i4-n20",
                        "F10 528i 3.0L I6 [N52]": "/collections/f10-528i-3-0l-i6-n52",
                        "F10 535i 3.0T I6 [N55]": "/collections/f10-535i-3-0t-i6-n55",
                        "F10 550i 4.4T V8 [N63]": "/collections/f10-550i-4-4t-v8-n63",
                        "F10 M5 4.4T V8 [S63]": "/collections/f10-m5-4-4t-v8-s63",
                        "F11 528i 3.0L I6 [N52]": "/collections/f11-528i-3-0l-i6-n52",
                        "F11 528i 2.0T I4 [N20]": "/collections/f11-528i-2-0t-i4-n20",
                        "F11 535i 3.0T I6 [N55]": "/collections/f11-535i-3-0t-i6-n55"
                    }
                },
                "G30": {
                    "models": {
                        "530i 2.0T I4 [B48]": "/collections/g30-f90-530i-2-0t-i4-b48",
                        "540i 3.0T I6 [B58]": "/collections/g30-f90-540i-3-0t-i6-b58",
                        "M550i 4.4T V8 [N63]": "/collections/g30-f90-m550i-4-4t-v8-n63",
                        "M5 4.4T V8 [S63]": "/collections/g30-f90-m5-4-4t-v8-s63"
                    }
                },
                "E63": {
                    "models": {
                        "645Ci 4.4L V8 [N62]": "/collections/e63-e64-645ci-4-4l-v8-n62",
                        "650i 4.8L V8 [N62]": "/collections/e63-e64-650i-4-8l-v8-n62",
                        "M6 5.0L V10 [S85]": "/collections/e63-e64-m6-5-0l-v10-s85"
                    }
                },
                "F06": {
                    "models": {
                        "F06 640i 3.0T I6 [N55]": "/collections/f06-640i-3-0t-i6-n55",
                        "F12 640i 3.0T I6 [N55]": "/collections/f12-640i-3-0t-i6-n55",
                        "F13 640i 3.0T I6 [N55]": "/collections/f13-640i-3-0t-i6-n55",
                        "F06 650i 4.4T V8 [N63]": "/collections/f06-650i-4-4t-v8-n63",
                        "F12 650i 4.4T V8 [N63]": "/collections/f12-650i-4-4t-v8-n63",
                        "F13 650i 4.4T V8 [N63]": "/collections/f13-650i-4-4t-v8-n63",
                        "M6 4.4T V8 [S63]": "/collections/f06-f12-f13-m6-4-4t-v8-s63"
                    }
                },
                "E38": {
                    "models": {
                        "740i 4.4L V8 [M62]": "/collections/e38-740i-4-4l-v8-m62",
                        "750iL 5.4L V12 [M73]": "/collections/e38-750i-5-4l-v12-m73"
                    }
                },
                "E65": {
                    "models": {
                        "745i 4.4L V8 [N62]": "/collections/e65-745i-4-4l-v8-n62",
                        "750i 4.8L V8 [N62]": "/collections/e65-750i-4-8l-v8-n62",
                        "750i 6.0L V12 [N73]": "/collections/e65-750i-6-0l-v8-n73"
                    }
                },
                "F01": {
                    "models": {
                        "740i 3.0T I6 [N54]": "/collections/f01-740i-3-0t-i6-n54",
                        "740i 3.0T I6 [N55]": "/collections/f01-740i-3-0t-i6-n55",
                        "750i 4.4T V8 [N63]": "/collections/f01-750i-4-4t-v8-n63"
                    }
                },
                "G11": {
                    "models": {
                        "740i 3.0T I6 [B58]": "/collections/g11-740i-3-0t-i6-b58",
                        "750i 4.4T V8 [N63]": "/collections/g11-750i-4-4t-v8-n63"
                    }
                },
                "G14": {
                    "models": {
                        "F91 M8 4.4T V8 [S63]": "/collections/f91-m8-4-4t-v8-s63",
                        "F92 M8 4.4T V8 [S63]": "/collections/f92-m8-4-4t-v8-s63",
                        "F93 M8 4.4T V8 [S63]": "/collections/f93-m8-4-4t-v8-s63"
                    }
                },
                "I12": {
                    "models": {
                        "i8 HYBRID 1.5T I3 [B38]": "/collections/i12-i8-hybrid-1-5t-i3-b38"
                    }
                },
                "F25": {
                    "models": {
                        "28i 2.0T I4 [N20]": "/collections/f25-28i-2-0t-i4-n20",
                        "28i 3.0L I6 [N52]": "/collections/f25-28i-3-0l-i6-n52",
                        "35i 3.0T I6 [N55]": "/collections/f25-35i-3-0t-i6-n55"
                    }
                },
                "E83": {
                    "models": {
                        "E83 X3 2.0i 2.0L I4 [N46]": "/collections/e83-x3-2-0i-2-0l-i4-n46",
                        "E83 X3 xDrive20i 2.0L I4 [N46]": "/collections/e83-x3-xdrive20i-2-0l-i4-n46",
                        "E83 X3 2.5i 2.5L I6 [M54]": "/collections/e83-x3-2-5i-2-5l-i6-m54",
                        "E83 X3 xDrive25i 2.5L I6 [N52]": "/collections/e83-x3-xdrive25i-2-5l-i6-n52",
                        "E83 X3 3.0i 3.0L I6 [M54]": "/collections/e83-x3-3-0i-3-0l-i6-m54",
                        "E83 X3 xDrive30i 3.0L I6 [N52]": "/collections/e83-x3-xdrive30i-3-0l-i6-n52"
                    }
                },
                "G01": {
                    "models": {
                        "xDrive30i 3.0T I6 [B58]": "/collections/g01-x3-xdrive30i-3-0t-i6-b58",
                        "M40i 3.0T I6 [B58]": "/collections/g01-x3-xdrive30i-3-0t-i6-b58"
                    }
                },
                "F26": {
                    "models": {
                        "xDrive28i 2.0T I4 [N20]": "/collections/f26-x4-xdrive28i-2-0t-i4-n63",
                        "xDrive35i 3.0T I6 [N55]": "/collections/f26-x4-xdrive35i-3-0t-i6-n55"
                    }
                },
                "G02": {
                    "models": {
                        "xDrive30i 2.0T I4 [B48]": "/collections/g02-x4-xdrive30i-2-0t-i4-b48",
                        "X4 M 3.0T I6 [S58]": "/collections/g02-x4-m-3-0t-i6-s58"
                    }
                },
                "E53": {
                    "models": {
                        "3.0i 3.0L I6 [M54]": "/collections/e53-x5-3-0i-3-0l-i6-m54",
                        "4.4i 4.4L V8 [M62]": "/collections/e53-x5-4-4i-4-4l-v8-m62",
                        "4.6is 4.6L V8 [M62]": "/collections/e53-x5-4-6is-4-6l-v8-m62",
                        "4.4i 4.4L V8 [N62]": "/collections/e53-x5-4-4i-4-4l-v8-n62",
                        "4.8is 4.8L V8 [N62]": "/collections/e53-x5-4-8is-4-8l-v8-n62"
                    }
                },
                "E70": {
                    "models": {
                        "35i 3.0T I6 [N55]": "/collections/e70-35i-3-0t-i6-n55",
                        "48i 4.8L V8 [N62]": "/collections/e70-48i-4-8l-v8-n62",
                        "50i 4.4T V8 [N63]": "/collections/e70-50i-4-4t-v8-n63",
                        "X5 M 4.4T V8 [S63]": "/collections/e70-m-4-4t-v8-s63"
                    }
                },
                "F15": {
                    "models": {
                        "35i 3.0T I6 [N55]": "/collections/f15-f85-35i-3-0t-i6-n55",
                        "50i 4.4T V8 [N63]": "/collections/f15-f85-50i-4-4t-v8-n63",
                        "X5 M 4.4T V8 [S63]": "/collections/f15-f85-m-4-4t-v8-s63"
                    }
                },
                "G05": {
                    "models": {
                        "xDrive30i 2.0T I4 [B48]": "/collections/g05-x5-xdrive30i-2-0t-i4-b48",
                        "xDrive40i 3.0T I6 [B58]": "/collections/g05-x5-xdrive40i-3-0t-i6-b58",
                        "xDrive50i 4.4T V8 [N63]": "/collections/g05-x5-xdrive50i-4-4t-v8-n63",
                        "M50i 4.4L V8 [N63]": "/collections/g05-x5-m50i-4-4l-v8-n63",
                        "X5 M 4.4T V8 [S63]": "/collections/g05-x5-m-4-4t-v8-s63"
                    }
                },
                "E71": {
                    "models": {
                        "35i 3.0T I6 [N55]": "/collections/e71-35i-3-0t-i6-n55",
                        "50i 4.4T V8 [N63]": "/collections/e71-50i-4-4t-v8-n63",
                        "X6 M 4.4T V8 [S63]": "/collections/e71-x6-m-4-4t-v8-s63"
                    }
                },
                "F16": {
                    "models": {
                        "35i 3.0T I6 [N55]": "/collections/f16-35i-3-0t-i6-n55",
                        "50i 4.4T V8 [N63]": "/collections/f16-50i-4-4t-v8-n63",
                        "X6 M 4.4T V8 [S63]": "/collections/f86-x6-m-4-4l-v8-s63"
                    }
                },
                "G06": {
                    "models": {
                        "xDrive40i 3.0T I6 [B58]": "/collections/g06-x6-xdrive40i-3-0t-i6-b58",
                        "X6 M 4.4T V8 [S63]": "/collections/g06-x6-m-4-4t-v8-s63"
                    }
                },
                "E36-7": {
                    "models": {
                        "2.5 2.5L I6 [M52]": "/collections/z3-2-5l-i6-m52",
                        "2.8 2.8L I6 [M52]": "/collections/z3-2-8l-i6-m52",
                        "2.5i 2.5L I6 [M54]": "/collections/z3-2-5l-i6-m54",
                        "M 3.2L I6 [S52]": "/collections/z3-3-2l-i6-s52",
                        "M 3.2L I6 [S54]": "/collections/z3-3-2l-i6-s54"
                    }
                },
                "E85": {
                    "models": {
                        "2.5i 2.5L I6 [M54]": "/collections/e85-e86-2-5i-2-5l-i6-m54",
                        "3.0i 3.0L I6 [M54]": "/collections/e85-e86-3-0i-3-0l-i6-m54",
                        "3.0i 3.0L I6 [N52]": "/collections/e85-e86-3-0i-3-0l-i6-n52",
                        "3.0iS 3.0L I6 [N52]": "/collections/e85-e86-3-0is-3-0l-i6-n52",
                        "M 3.2L I6 [S54]": "/collections/e85-e86-m-3-2l-i6-s54"
                    }
                },
                "E89": {
                    "models": {
                        "28i 2.0T I4 [N20]": "/collections/e89-28i-2-0t-i4-n20",
                        "30i 3.0L I6 [N52]": "/collections/e89-30i-3-0l-i6-n52",
                        "35i 3.0T I6 [N54]": "/collections/e89-35i-3-0t-i6-n54",
                        "35iS 3.0T I6 [N54]": "/collections/e89-35is-3-0t-i6-n54"
                    }
                },
                "G29": {
                    "models": {
                        "sDrive20i 2.0T I4 [B48]": "/collections/g29-z4-sdrive20i-2-0t-b48",
                        "sDrive30i 2.0L I4 [NB48]": "/collections/g29-z4-sdrive30i-2-0t-b48",
                        "M40i 3.0T I6 [B58]": "/collections/g29-z4-M40i-3-0t-b58"
                    }
                },
                "E52": {
                    "models": {
                        "Z8 4.8L V8 [S62]": "/collections/e52-z8-4-8l-v8-s62"
                    }
                }
            }
        },
        {
            "Porsche": {
                "964": {
                    "models": {
                        "Carrera RS 3.6L Flat-6": "/collections/964-carrera-rs-3-6l-flat-6",
                        "Turbo 3.3T Flat-6": "/collections/964-turbo-3-3t-flat-6",
                        "Turbo 3.6T Flat-6": "/collections/964-turbo-3-6t-flat-6"
                    }
                },
                "993": {
                    "models": {
                        "Turbo 3.6T Flat-6": "/collections/993-turbo-3-6t-flat-6"
                    }
                },
                "996": {
                    "models": {
                        "996.1 Carrera 3.4L Flat-6": "/collections/996-1-carrera-3-4l-flat-6",
                        "996.1 Carrera 4 3.4L Flat-6": "/collections/996-1-carrera-4-3-4l-flat-6",
                        "996.2 Carrera/C4 3.6L Flat-6": "/collections/996-2-carrera-c4-3-6l-flat-6",
                        "996.2 Carrera 4S 3.6L Flat-6": "/collections/996-2-carrera-4s-3-6l-flat-6",
                        "996.2 Turbo 3.6T Flat-6": "/collections/996-2-turbo-3-6t-flat-6",
                        "996.2 Turbo S 3.6T Flat-6": "/collections/996-2-turbo-s-3-6t-flat-6",
                        "996.2 GT3 3.6L Flat-6": "/collections/996-2-gt3-3-6l-flat-6",
                        "996.2 GT3 RS 3.6L Flat-6": "/collections/996-2-gt3-rs-3-6l-flat-6",
                        "996.2 GT2 3.6T Flat-6": "/collections/996-2-gt2-3-6t-flat-6",
                        "996.2 GT3 Cup 3.6L Flat-6": "/collections/996-2-gt3-cup-3-6l-flat-6"
                    }
                },
                "997.1": {
                    "models": {
                        "Carrera 3.6L Flat-6": "/collections/997-1-carrera-3-6l-flat-6",
                        "Carrera S 3.8L Flat-6": "/collections/997-1-carrera-s-3-8l-flat-6",
                        "Carrera 4 3.6L Flat-6": "/collections/997-1-carrera-4-3-6l-flat-6",
                        "Carrera 4S 3.8L Flat-6": "/collections/997-1-carrera-4s-3-8l-flat-6",
                        "Targa 4 3.6L Flat-6": "/collections/997-1-targa-4-3-6l-flat-6",
                        "Targa 4S 3.8L Flat-6": "/collections/997-1-targa-4s-3-8l-flat-6",
                        "GT3 3.6L Flat-6": "/collections/997-1-gt3-3-6l-flat-6",
                        "Turbo 3.6T Flat-6": "/collections/997-1-turbo-3-6t-flat-6",
                        "GT2 3.6T Flat-6": "/collections/997-1-gt2-3-6t-flat-6",
                        "GT3 Cup 3.6L Flat-6": "/collections/997-1-gt3-cup-3-6l-flat-6"
                    }
                },
                "997.2": {
                    "models": {
                        "Carrera 3.6L Flat-6": "/collections/997-2-carrera-3-6l-flat-6",
                        "Carrera S 3.8L Flat-6": "/collections/997-2-carrera-s-3-8l-flat-6",
                        "Carrera 4 3.6L Flat-6": "/collections/997-2-carrera-4-3-6l-flat-6",
                        "Carrera 4S 3.8L Flat-6": "/collections/997-2-carrera-4s-3-8l-flat-6",
                        "Turbo 3.8T Flat-6": "/collections/997-2-turbo-3-8t-flat-6",
                        "GT3 3.8L Flat-6": "/collections/997-2-gt3-3-8l-flat-6",
                        "GT3 Cup 3.6L Flat-6": "/collections/997-2-gt3-cup-3-6l-flat-6"
                    }
                },
                "991.1": {
                    "models": {
                        "Carrera 3.4L Flat-6": "/collections/991-1-carrera-3-4l-flat-6",
                        "Carrera S 3.8L Flat-6": "/collections/991-1-carrera-s-3-8l-flat-6",
                        "Carrera GTS 3.8L Flat-6": "/collections/991-1-carrera-gts-3-8l-flat-6",
                        "Carrera 4 3.4L Flat-6": "/collections/991-1-carrera-4-3-4l-flat-6",
                        "Carrera 4S 3.8L Flat-6": "/collections/991-1-carrera-4s-3-8l-flat-6",
                        "Carrera 4 GTS 3.8L Flat-6": "/collections/991-1-carrera-4-gts-3-8l-flat-6",
                        "Targa 4 3.4L Flat-6": "/collections/991-1-targa-4-3-4l-flat-6",
                        "Targa 4S 3.8L Flat-6": "/collections/991-1-targa-4s-3-8l-flat-6",
                        "Targa 4 GTS 3.8L Flat-6": "/collections/991-1-targa-4-gts-3-8l-flat-6",
                        "991.1 GT3 3.8L Flat-6": "/collections/991-1-gt3-3-8l-flat-6",
                        "GT3 RS 4.0L Flat-6": "/collections/991-1-gt3-rs-4-0l-flat-6",
                        "Turbo 3.8T Flat-6": "/collections/991-1-turbo-3-8t-flat-6",
                        "Turbo S 3.8T Flat-6": "/collections/991-1-turbo-s-3-8t-flat-6",
                        "GT3 Cup 4.0L Flat-6": "/collections/991-1-gt3-cup-4-0l-flat-6"
                    }
                },
                "991.2": {
                    "models": {
                        "Carrera 3.0L Flat-6": "/collections/991-2-carrera-3-0l-flat-6",
                        "Carrera T 3.0L Flat-6": "/collections/991-2-carrera-t-3-0l-flat-6",
                        "Carrera S 3.0L Flat-6": "/collections/991-2-carrera-s-3-0l-flat-6",
                        "Carrera GTS 3.0L Flat-6": "/collections/991-2-carrera-gts-3-0l-flat-6",
                        "Carrera 4S 3.0L Flat-6": "/collections/991-2-carrera-4s-3-0l-flat-6",
                        "GT3 4.0L Flat-6": "/collections/991-2-gt3-4-0l-flat-6",
                        "GT3 RS 4.0L Flat-6": "/collections/991-2-gt3-rs-4-0l-flat-6",
                        "Turbo 3.8T Flat-6": "/collections/991-2-turbo-3-8t-flat-6",
                        "Turbo S 3.8T Flat-6": "/collections/991-2-turbo-s-3-8t-flat-6",
                        "GT2 RS 3.8T Flat-6": "/collections/991-2-gt2-rs-3-8t-flat-6",
                        "GT2 RS Clubsport 3.8T Flat-6": "/collections/991-2-gt2-rs-clubsport-3-8t-flat-6",
                        "GT3 Cup 4.0L Flat-6": "/collections/991-2-gt3-cup-4-0l-flat-6"
                    }
                },
                "986": {
                    "models": {
                        "Boxster S 3.2L Flat-6": "/collections/986-boxster-s-3-2l-flat-6"
                    }
                },
                "987": {
                    "models": {
                        "987.1 Boxster 2.7L Flat-6": "/collections/987-1-boxster-2-7l-flat-6",
                        "987.1 Boxster S 3.2L Flat-6": "/collections/987-1-boxster-s-3-2l-flat-6",
                        "987.1 Boxster S 3.4L Flat-6": "/collections/987-1-boxster-s-3-4l-flat-6",
                        "987.2 Boxster 2.9L Flat-6": "/collections/987-2-boxster-2-9l-flat-6",
                        "987.2 Boxster S 3.4L Flat-6": "/collections/987-2-boxster-s-3-4l-flat-6"
                    }
                },
                "981": {
                    "models": {
                        "Boxster 2.7L Flat-6": "/collections/981-boxster-2-7l-flat-6",
                        "Boxster Spyder 3.8L Flat-6": "/collections/981-boxster-spyder-3-8l-flat-6",
                        "Boxster S 3.4L Flat-6": "/collections/981-boxster-s-3-4l-flat-6",
                        "Boxster GTS 3.4L Flat-6": "/collections/981-boxster-gts-3-4l-flat-6"
                    }
                },
                "982718_": {
                    "models": {
                        "Boxster 2.0T Flat-4": "/collections/982-718-boxster-2-0t-flat-4",
                        "Boxster S 2.5T Flat-4": "/collections/982-718-boxster-s-2-5t-flat-4",
                        "Boxster GTS 2.5T Flat-4": "/collections/982-718-boxster-gts-2-5t-flat-4",
                        "Boxster GTS 4.0L Flat-6": "/collections/982-718-boxster-gts-4-0l-flat-6",
                        "Boxster Spyder 2.5T Flat-4": "/collections/982-718-boxster-spyder-2-5t-flat-4"
                    }
                },
                "987c": {
                    "models": {
                        "987.1 Cayman R 3.4L Flat-6": "/collections/987-1-cayman-r-3-4l-flat-6",
                        "987.2 Cayman R 3.4L Flat-6": "/collections/987-2-cayman-r-3-4l-flat-6",
                        "987.1 Cayman S 3.2L Flat-6": "/collections/987-1-cayman-s-3-2l-flat-6",
                        "987.2 Cayman S 3.4L Flat-6": "/collections/987-2-cayman-s-3-4l-flat-6"
                    }
                },
                "981c": {
                    "models": {
                        "Cayman 2.7L Flat-6": "/collections/981-cayman-2-7l-flat-6",
                        "Cayman GT4 3.8L Flat-6": "/collections/981-cayman-gt4-3-8l-flat-6"
                    }
                },
                "982c": {
                    "models": {
                        "Cayman 2.0T Flat-4": "/collections/982-718-cayman-2-0t-flat-4",
                        "Cayman GT4 4.0L Flat-6": "/collections/982-718-cayman-gt4-4-0l-flat-6",
                        "Cayman GT4 RS 4.0L Flat-6": "/collections/982-718-cayman-gt4-rs-4-0l-flat-6",
                        "Cayman GT4 Clubsport 3.8L Flat-6": "/collections/982-718-cayman-gt4-clubsport-3-8l-flat-6"
                    }
                },
                "95B": {
                    "models": {
                        "Base 2.0T I4": "/collections/95b-base-2-0t-i4",
                        "S 3.0T V6": "/collections/95b-s-3-0t-v6",
                        "GTS 3.0T V6": "/collections/95b-gts-3-0t-v6",
                        "Turbo 3.6T V6": "/collections/95b-turbo-3-6t-v6"
                    }
                },
                "958": {
                    "models": {
                        "Cayenne 3.6L VR6": "/collections/92a-cayenne-3-6l-vr6",
                        "Cayenne S 4.8L V8": "/collections/92a-cayenne-s-4-8l-v8",
                        "Cayenne GTS 4.8L V8": "/collections/92a-cayenne-gts-4-8l-v8",
                        "Cayenne GTS 3.6T V6": "/collections/92a-cayenne-gts-3-6t-v6",
                        "Cayenne Turbo 4.8T V8": "/collections/92a-cayenne-turbo-4-8t-v8",
                        "Cayenne Turbo S 4.8T V8": "/collections/92a-cayenne-turbo-s-4-8t-v8",
                        "Cayenne Diesel 3.0T V6": "/collections/92a-cayenne-diesel-3-0t-v6",
                        "Cayenne S Diesel 4.1T V8": "/collections/92a-cayenne-s-diesel-4-1t-v8"
                    }
                },
                "955": {
                    "models": {
                        "Cayenne 3.2L VR6": "/collections/9pa-cayenne-3-2l-vr6",
                        "Cayenne 3.6L VR6": "/collections/9pa-cayenne-3-6l-vr6",
                        "Cayenne S 4.5L V8": "/collections/9pa-cayenne-s-4-5l-v8",
                        "Cayenne GTS 4.8L V8": "/collections/9pa-cayenne-gts-4-8l-v8",
                        "Cayenne Turbo 4.5T V8": "/collections/9pa-cayenne-turbo-4-5t-v8",
                        "Cayenne Turbo S 4.5T V8": "/collections/9pa-cayenne-turbo-s-4-5t-v8",
                        "Cayenne Turbo 4.8T V8": "/collections/9pa-cayenne-turbo-4-8t-v8",
                        "Cayenne Turbo S 4.8T V8": "/collections/9pa-cayenne-turbo-s-4-8t-v8"
                    }
                }
            }
        },
        {
            "Toyota": {
                "A90": {
                    "models": {
                        "A90 · A91 Supra 2.0T I4 [B48]": "/collections/a90-a91-supra-2-0t-i4-b48/",
                        "A90 · A91 Supra 3.0T I6 [B58]": "/collections/a90-a91-supra-3-0t-i6-b58/"
                    }
                }
            }
        },
        {
            "INEOS": {
                "Grenadier": {
                    "models": {
                        "Grenadier 3.0T I6 [B58]": "/collections/ineos-grenadier-3-0t-i6-b58",
                        "Grenadier Diesel 3.0T I6 [B57]": "/collections/ineos-grenadier-diesel-3-0t-i6-b57"
                    }
                }
            }
        },
        {
            "Mercedes-Benz": {
                "W176": {
                    "models": {
                        "AMG A 45 2.0T I4 [M133]": "/collections/w176-amg-a-45-2-0t-i4-m133",
                    }
                },
                "W177": {
                    "models": {
                        "A250 2.0T I4 [M260]": "/collections/w177-a250-2-0t-i4-m260",
                        "A35 AMG 2.0T I4 [M260]" : "/collections/w177-a35-amg-2-0t-i4-m260",
                        "A45 AMG 2.0T I4 [M139]" : "/collections/w177-a45-amg-2-0t-i4-m139",
                        "A45S AMG 2.0T I4 [M139]" : "/collections/w177-a45s-amg-2-0t-i4-m139"
                    }
                },
                "C190": {
                    "models": {
                        "AMG GT 4.0T V8": "/collections/c190-amg-gt-4-0t-v8",
                        "AMG GT S 4.0T V8" : "/collections/c190-amg-gt-s-4-0t-v8",
                        "AMG GT R 4.0T V8]": "/collections/c190-amg-gt-r-4-0t-v8",
                    }
                },
                "X290": {
                    "models": {
                        "AMG GT 63 S 4.0T V8 [M177]" : "/collections/x290-amg-gt-63-s-4-0t-v8-m177",
                        "AMG GT 63 4.0T V8 [M177]" : "/collections/x290-amg-gt-63-4-0t-v8-m177",
                    }
                },
                "W205": {
                    "models": {
                        "AMG C 63 4.0T V8": "/collections/w205-amg-c-63-4-0t-v8",
                        "AMG C 63 S 4.0T V8" : "/collections/w205-amg-c-63-s-4-0t-v8",
                        "C 400 3.0T V6 [M276]" : "/collections/w205-c-400-3-0t-v6-m276",
                    }
                },
                "C117/X117": {
                    "models": {
                        "AMG CLA 45 2.0T I4 [M133]" : "/collections/c118-cla250-2-0t-i4-m260",
                    }
                },
                "C118/X118": {
                    "models": {
                        "CLA35 AMG 2.0T I4 [M260]" : "/collections/c118-cla35-amg-2-0t-i4-m260",
                        "CLA45 AMG 2.0T I4 [M139]" : "/collections/c118-cla45-amg-2-0t-i4-m139",
                        "CLA45S AMG 2.0T I4 [M139]" : "/collections/c118-cla45s-amg-2-0t-i4-m139",
                    }
                },
                "C218": {
                    "models": {
                        "AMG CLS 63 5.5T V8 [M157]" : "/collections/c218-amg-cls-63-5-5t-v8-m157",
                        "CLS 400 3.0T V6 [M276]" : "/collections/c218-cls-400-3-0t-v6-m276"
                    }
                },
                "W212": {
                    "models": {
                        "AMG E 63 5.5L V8 [M157]":"/collections/w212-amg-e-63-5-5l-v8-m157",
                        "AMG E 63 S 5.5L V8 [M157]":"/collections/w212-amg-e-63-s-5-5l-v8-m157",
                        "E 550 5.5L V8 [M157]":"/collections/w212-e-550-5-5l-v8-m157",
                    }
                },
                "W213": {
                    "models": {
                        "AMG E 43 3.0T V6 [M276]":"/collections/w213-amg-e-43-3-0t-v6-m276",
                        "AMG E 63 4.0T V8 [M177]":"/collections/w213-amg-e-63-4-0t-v8-m177",
                        "AMG E 63 S 4.0T V8 [M177]":"/collections/w213-amg-e-63-s-4-0t-v8-m177",
                        "E 400 3.0T V6 [M276]":"/collections/w213-e-400-3-0t-v6-m276",
                    }
                },
                "W463": {
                    "models": {
                        "AMG G 63 5.5T V8 [M157]" : "/collections/w463-amg-g-63-5-5t-v8-m157",
                        "AMG G 65 6.0L V12 [M117]" : "/collections/w463-amg-g-65-6-0l-v12-m117",
                        "G 550 4.0T V8 [M176]" : "/collections/w463-g-550-4-0t-v8-m176"
                    }
                },
                "X156": {
                    "models": {
                        "AMG GLA 45 2.0T I4 [M133]" : "/collections/x156-amg-gla-45-2-0t-i4-m133"
                    }
                },
                "C253/X253": {
                    "models": {
                        "AMG GLC 63 S 4.0T V8" : "/collections/c253-amg-glc-63-s-4-0t-v8",
                        "AMG GLC 43 3.0T V6 [M276]" : "/collections/x253-amg-glc-43-3-0t-v6-m276"
                    }
                },
                "W167": {
                    "models": {
                        "AMG GLE 63 S 4.0T V8 [M177]" : "/collections/w167-amg-gle-63-s-4-0t-v8-m177"
                    }
                },
                "W222": {
                    "models": {
                        "AMG S 63 4.0T V8 [M177]" : "/collections/w222-amg-s-63-4-0t-v8-m177",
                        "S 550 4.7T V8 [M278]" : "/collections/w222-s-550-4-7t-v8-m278",
                        "S 560 4.0T V8 [M177]" : "/collections/w222-s-560-4-0t-v8-m177"
                    }
                },
                "W206": {
                    "models": {
                        "AMG SL 63 5.5T V8 [M157]" : "/collections/r231-amg-sl-63-5-5t-v8-m157",
                        "AMG SL 65 6.0T V12 [M279]" : "/collections/r231-amg-sl-65-6-0t-v12-m279",
                        "SL 400 3.0T V6 [M276]" : "/collections/r231-sl-400-3-0t-v6-m276",
                        "SL 450 3.0T V6 [M276]" : "/collections/r231-sl-450-3-0t-v6-m276",
                        "SL 550 4.7T V8 [M278]" : "/collections/r231-sl-550-4-7t-v8-m278",
                    }
                }
            }
        },
        {
            "VW": {
                "MK1 Arteon": {
                    "models": {
                        "Arteon 2.0T I4 [MQB]": "/collections/mk1-arteon-2-0t-i4-mqb/"
                    }
                },
                "MK1 Atlas": {
                    "models": {
                        "Atlas 2.0T I4 [MQB]": "/collections/mk1-atlas-2-0t-i4-mqb/",
                        "Atlas 3.6L VR6 [MQB]": "/collections/mk1-atlas-3-6l-vr6-mqb/",
                        "Atlas Cross Sport 2.0T I4 [MQB]": "/collections/mk1-atlas-cross-sport-2-0t-i4-mqb/",
                        "Atlas Cross Sport 3.6L VR6 [MQB]": "/collections/mk1-atlas-cross-sport-3-6l-vr6-mqb/"
                    }
                },
                "MK1 Beetle": {
                    "models": {
                        "Beetle 1.8T I4": "/collections/mk1-beetle-1-8t-i4/"
                    }
                },
                "5C": {
                    "models": {
                        "Beetle 1.8T I4 [GEN 3]": "/collections/5c-beetle-1-8t-i4-gen-3/",
                        "Beetle 2.0L TDI I4": "/collections/5c-beetle-2-0l-tdi-i4/",
                        "Beetle 2.0T I4": "/collections/5c-beetle-2-0t-i4/",
                        "Beetle 2.0T I4 [GEN 3]": "/collections/5c-beetle-2-0t-i4-gen-3/",
                        "Beetle 2.5L I5": "/collections/5c-beetle-2-5l-i5/"
                    }
                },
                "B6 CC": {
                    "models": {
                        "CC 2.0T I4": "/collections/b6-cc-2-0t-i4/",
                        "CC 3.6L VR6": "/collections/b6-cc-3-6l-vr6/"
                    }
                },
                "1F EOS": {
                    "models": {
                        "EOS 2.0T I4": "/collections/1f-eos-2-0t-i4/",
                        "EOS 3.2L VR6": "/collections/1f-eos-3-2l-vr6/"
                    }
                },
                "MK2 Golf": {
                    "models": {
                        "Golf 8V": "/collections/mk2-golf-8v/",
                        "Golf 16V": "/collections/mk2-golf-16v/",
                        "Rabbit 8V": "/collections/mk2-rabbit-8v/",
                        "Rabbit 16V": "/collections/mk2-rabbit-16v/",
                        "GTI 8V": "/collections/mk2-gti-8v/",
                        "GTI 16V": "/collections/mk2-gti-16v/"
                    }
                },
                "MK3 Golf": {
                    "models": {
                        "Golf 2.0L 8V": "/collections/mk3-golf-2-0l-8v/",
                        "Golf 2.8L VR6 12V": "/collections/mk3-golf-2-8l-vr6-12v/",
                        "Rabbit 2.0L 8V": "/collections/mk3-rabbit-2-0l-8v/",
                        "GTI 2.0L 8V": "/collections/mk3-gti-2-0l-8v/"
                    }
                },
                "MK4 Golf": {
                    "models": {
                        "Golf 2.0L I4": "/collections/mk4-golf-2-0l-i4/",
                        "Rabbit 1.8T": "/collections/mk4-rabbit-1-8t/",
                        "Rabbit 2.0L 8V": "/collections/mk4-rabbit-2-0l-8v/",
                        "GTI 1.8T I4": "/collections/mk4-gti-1-8t-i4/",
                        "GTI 2.8L VR6": "/collections/mk4-gti-2-8l-vr6/",
                        "R32 3.2L VR6": "/collections/mk4-r32-3-2l-vr6/"
                    }
                },
                "MK5 Golf": {
                    "models": {
                        "GTI 2.0T I4": "/collections/mk5-gti-2-0t-i4/",
                        "Rabbit 2.5L I5": "/collections/mk5-rabbit-2-5l-i5/",
                        "R32 3.2L VR6": "/collections/mk5-r32-3-2l-vr6/"
                    }
                },
                "MK6 Golf": {
                    "models": {
                        "Golf 2.0L TDI I4": "/collections/mk6-golf-2-0l-tdi-i4/",
                        "Golf 2.5L I5": "/collections/mk6-golf-2-5l-i5/",
                        "GTI 2.0T I4": "/collections/mk6-gti-2-0t-i4/",
                        "R 2.0T I4": "/collections/mk6-r-2-0t-i4/"
                    }
                },
                "MK7 Golf": {
                    "models": {
                        "Golf 1.4T I4 [MQB]": "/collections/mk7-golf-1-4t-i4-mqb/",
                        "Golf 1.8T I4 [MQB]": "/collections/mk7-golf-1-8t-i4-mqb/",
                        "Golf 2.0L TDI I4 [MQB]": "/collections/mk7-golf-2-0l-tdi-i4-mqb/",
                        "Golf Alltrack 1.8T I4 [MQB]": "/collections/mk7-golf-alltrack-1-8t-i4-mqb/",
                        "Golf Sportwagen 1.4T I4 [MQB]": "/collections/mk7-golf-sportwagen-1-4t-i4-mqb/",
                        "Golf Sportwagen 1.8T I4 [MQB]": "/collections/mk7-golf-sportwagen-1-8t-i4-mqb/",
                        "Golf Sportwagen 2.0L TDI I4 [MQB]": "/collections/mk7-golf-sportwagen-2-0l-tdi-i4-mqb/",
                        "GTI 2.0T I4 [MQB]": "/collections/mk7-gti-2-0t-i4-mqb/",
                        "R 2.0T I4 [MQB]": "/collections/mk7-r-2-0t-i4-mqb/"
                    }
                },
                "MK8 Golf": {
                    "models": {
                        "GTI 2.0T I4 [MQB Evo]": "/collections/mk8-gti-2-0t-i4-mqb-evo/",
                        "R 2.0T I4 [MQB Evo]": "/collections/mk8-r-2-0t-i4-mqb-evo/"
                    }
                },
                "MK8.5 Golf": {
                    "models": {
                        "MK8.5 GTI 2.0T I4": "/collections/mk8-5-gti-2-0t-i4",
                        "MK8.5 R 2.0T I4": "/collections/mk8-5-r-2-0t-i4"
                    }
                },
                "MK2 Jetta" : {
                    "models": {
                        "Jetta 8V":"/collections/1g-jetta-8v/",
                        "Jetta 16V":"/collections/1g-jetta-16/",
                        "Jetta GLI 8V":"/collections/1g-jetta-gli-8v/",
                        "Jetta GLI 16V":"/collections/1g-jetta-gli-16/"
                    }
                },
                "MK3 Jetta": {
                    "models": {
                        "Jetta 2.0L 8V":"/collections/1h-jetta-2-0l-8v/",
                        "Jetta 2.8L VR6 12V":"/collections/1h-jetta-2-8l-vr6-12v/",
                        "Jetta GLI 2.0L 8V":"/collections/1h-jetta-gli-2-0l-8v/",
                    }
                },
                "MK4 Jetta": {
                    "models": {
                        "Jetta 2.0L I4": "/collections/1j-jetta-2-0l-i4/",
                        "Jetta GLI 1.8T I4": "/collections/1j-jetta-gli-1-8t-i4/",
                        "Jetta GLI 2.8L VR6":"/collections/1j-jetta-gli-2-8l-vr6/"
                    }
                },
                "MK5 Jetta": {
                    "models": {
                        "Jetta 2.5L I5" : "/collections/1k-jetta-2-5l-i5/",
                        "Jetta 1.9 TDI I4" : "/collections/1k-jetta-1-9-tdi-i4/",
                        "Jetta GLI 2.0T I4" : "/collections/1k-jetta-gli-2-0t-i4/"
                    }
                },
                "MK6 Jetta": {
                    "models": {
                        "Jetta 1.4T I4": "/collections/1b-jetta-1-4t-i4/",
                        "Jetta S 2.0L I4": "/collections/1b-jetta-s-2-0l-i4/",
                        "Jetta 1.8T I4 [GEN 3]":"/collections/1b-jetta-1-8t-i4-gen-3/",
                        "Jetta 2.0L TDI I4": "/collections/1b-jetta-2-0l-tdi-i4/",
                        "Jetta 2.5L I5":"/collections/1b-jetta-2-5l-i5/",
                        "Jetta GLI 2.0T I4":"/collections/1b-jetta-gli-2-0t-i4/",
                        "Jetta GLI 2.0T I4 [GEN 3]":"/collections/1b-jetta-gli-2-0t-i4-gen-3/"
                    }
                },
                "MK7 Jetta": {
                    "models": {
                        "Jetta 1.4T I4 [MQB]": "/collections/mk7-jetta-1-4t-i4-mqb/",
                        "Jetta GLI 2.0T I4 [MQB]": "/collections/mk7-jetta-gli-2-0t-i4-mqb/"
                    }
                },
                "B3 Passat": {
                    "models": {
                        "Passat 2.0L 16V": "/collections/b3-passat-2-0l-16v/"
                    }
                },
                "B4 Passat": {
                    "models": {
                        "Passat 2.0L 8V": "/collections/b4-passat-2-0l-8v/"
                    }
                },
                "B5 Passat": {
                    "models": {
                        "Passat 1.8T I4": "/collections/b5-passat-1-8t-i4/",
                        "Passat 2.8L V6": "/collections/b5-passat-2-8l-v6/",
                        "Passat 4.0L W8": "/collections/b5-passat-4-0l-w8/"
                    }
                },
                "B6 Passat": {
                    "models": {
                        "Passat 2.0T I4": "/collections/b6-passat-2-0t-i4/",
                        "Passat 2.0L TDI I4": "/collections/b6-passat-2-0l-tdi-i4/",
                        "Passat 3.6L VR6": "/collections/b6-passat-3-6l-vr6/"
                    }
                },
                "B7 Passat": {
                    "models": {
                        "Passat 1.8T I4 [GEN 3]": "/collections/b7-passat-1-8t-i4-gen-3/",
                        "Passat 2.0T I4 [GEN 3B]": "/collections/b7-passat-2-0t-i4-gen-3b/",
                        "Passat 2.5L I5": "/collections/b7-passat-2-5l-i5/",
                        "Passat 3.6L VR6": "/collections/b7-passat-3-6l-vr6/"
                    }
                },
                "B8 Passat": {
                    "models": {
                        "Passat 2.0T I4 [GEN 3B]": "/collections/b8-passat-2-0t-i4-gen-3B/"
                    }
                },
                "5N Tiguan": {
                    "models": {
                        "Tiguan 2.0T I4": "/collections/5n-tiguan-2-0t-i4/"
                    }
                },
                "5NA Tiguan": {
                    "models": {
                        "Tiguan 2.0T I4 [MQB]": "/collections/5na-tiguan-2-0t-i4-mqb/",
                        "Tiguan R 2.0T I4 [MQB]": "/collections/5na-tiguan-r-2-0t-mqb/"
                    }
                },
                "7L Touareg": {
                    "models": {
                        "3.2L VR6": "/collections/7l-touareg-3-2l-vr6",
                        "3.6L VR6": "/collections/7l-touareg-3-6l-vr6",
                        "4.2L V8": "/collections/7l-touareg-4-2l-v8",
                        "6.0L W12": "/collections/7l-touareg-6-0l-w12",
                        "2.5L I5 TDI": "/collections/7l-touareg-2-5l-i5-tdi",
                        "3.0L V6 TDI": "/collections/7l-touareg-3-0l-v6-tdi",
                        "5.0L V10 TDI": "/collections/7l-touareg-5-0l-v10-tdi"
                    }
                },
                "7P Touareg": {
                    "models": {
                        "Touareg - All Engines": "/collections/7p-touareg-2011-2017/"
                    }
                }
            }
        }
    ]
    
    return data;
}

